import {apiClient} from "../../AxiosConfig";
import {useQuery} from "@tanstack/react-query";
import UserStore from "../../store/user-store";
import ConfigStore from "../../store/config-store";
import {toJS} from "mobx";
import {useEffect, useCallback} from 'react';


const fetchConfigs = async () => {
    const response = await apiClient("/v1/config/");
    return response.data;
}


export const useFetchConfigs = () => {
    const {data, isLoading, isSuccess} = useQuery(
        {
            queryKey: ['configs'],
            queryFn: () => fetchConfigs(),
            enabled: Boolean(UserStore.userActivePlanData && UserStore.userActivePlanData.length > 0),
        }
    )

    if (data && isSuccess) {
        ConfigStore.setConfig(data);
    }


    return {isLoading, data}
}